// import React, { useState, useEffect } from 'react';
// import NoImageFound from "../../../../assets/img/nfts/no_image.png";
//
// const RATINGS_KEY = 'cromptonRecipeRatings';
//
// const RecipeDetail = ({ recipe, onBack, isBookmarked, onToggleBookmark }) => {
//     const [activeTab, setActiveTab] = useState('ingredients');
//     const [userRating, setUserRating] = useState(0);
//     const [hoveredRating, setHoveredRating] = useState(0);
//     const [hasRated, setHasRated] = useState(false);
//     const [showRatingCard, setShowRatingCard] = useState(false);
//     const [tempRating, setTempRating] = useState(0);
//
//     // ✅ Load saved rating
//     useEffect(() => {
//         if (recipe?.recipeId) {
//             try {
//                 const stored = localStorage.getItem(RATINGS_KEY);
//                 if (stored) {
//                     const allRatings = JSON.parse(stored);
//                     if (allRatings[recipe.recipeId]) {
//                         setUserRating(allRatings[recipe.recipeId]);
//                         setHasRated(true);
//                         setShowRatingCard(false);
//                     } else {
//                         setUserRating(0);
//                         setHasRated(false);
//                         setShowRatingCard(false);
//                     }
//                 } else {
//                     setUserRating(0);
//                     setHasRated(false);
//                     setShowRatingCard(false);
//                 }
//             } catch (error) {
//                 console.error('Error loading rating:', error);
//             }
//         }
//     }, [recipe?.recipeId]);
//
//     // ✅ Submit rating
//     const handleSubmitRating = () => {
//         if (tempRating === 0) return;
//         try {
//             const stored = localStorage.getItem(RATINGS_KEY);
//             const allRatings = stored ? JSON.parse(stored) : {};
//             allRatings[recipe.recipeId] = tempRating;
//             localStorage.setItem(RATINGS_KEY, JSON.stringify(allRatings));
//             setUserRating(tempRating);
//             setHasRated(true);
//             setShowRatingCard(false);
//         } catch (error) {
//             console.error('Error saving rating:', error);
//         }
//     };
//
//     // ✅ Skip rating
//     const handleSkip = () => {
//         setShowRatingCard(false);
//         setTempRating(0);
//         setHoveredRating(0);
//     };
//
//     // ✅ Remove rating
//     const handleRemoveRating = () => {
//         try {
//             const stored = localStorage.getItem(RATINGS_KEY);
//             if (stored) {
//                 const allRatings = JSON.parse(stored);
//                 delete allRatings[recipe.recipeId];
//                 localStorage.setItem(RATINGS_KEY, JSON.stringify(allRatings));
//             }
//             setUserRating(0);
//             setTempRating(0);
//             setHasRated(false);
//             setHoveredRating(0);
//             setShowRatingCard(false);
//         } catch (error) {
//             console.error('Error removing rating:', error);
//         }
//     };
//
//     // ✅ Half Star SVG Component
//     const StarIcon = ({ filled, half, size = 'w-14 h-14' }) => (
//         <svg
//             viewBox="0 0 24 24"
//             className={`${size} transition-all duration-150 drop-shadow-sm`}
//         >
//             <defs>
//                 <linearGradient id={`half-${size}`}>
//                     <stop offset="50%" stopColor="#facc15" />
//                     <stop offset="50%" stopColor="transparent" />
//                 </linearGradient>
//             </defs>
//             {half ? (
//                 // ✅ Half filled star
//                 <>
//                     {/* Gray background star */}
//                     <path
//                         d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
//                         fill="#e5e7eb"
//                         stroke="#d1d5db"
//                         strokeWidth={0.5}
//                     />
//                     {/* Yellow left half */}
//                     <clipPath id="left-half">
//                         <rect x="0" y="0" width="12" height="24" />
//                     </clipPath>
//                     <path
//                         d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
//                         fill="#facc15"
//                         stroke="#facc15"
//                         strokeWidth={0.5}
//                         clipPath="url(#left-half)"
//                     />
//                 </>
//             ) : filled ? (
//                 // ✅ Full filled star
//                 <path
//                     d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
//                     fill="#facc15"
//                     stroke="#facc15"
//                     strokeWidth={0.5}
//                 />
//             ) : (
//                 // ✅ Empty star
//                 <path
//                     d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
//                     fill="#e5e7eb"
//                     stroke="#d1d5db"
//                     strokeWidth={0.5}
//                 />
//             )}
//         </svg>
//     );
//
//     // ✅ Render stars based on rating value (supports 0.5 steps)
//     const renderStars = (rating, size = 'w-14 h-14', interactive = false) => {
//         return [1, 2, 3, 4, 5].map((star) => {
//             const isFull = rating >= star;
//             const isHalf = !isFull && rating >= star - 0.5;
//
//             if (!interactive) {
//                 return (
//                     <StarIcon
//                         key={star}
//                         filled={isFull}
//                         half={isHalf}
//                         size={size}
//                     />
//                 );
//             }
//
//             // ✅ Interactive star with left/right half click zones
//             return (
//                 <div
//                     key={star}
//                     className="relative cursor-pointer hover:scale-125 transition-all duration-150"
//                     onMouseLeave={() => setHoveredRating(0)}
//                 >
//                     {/* ✅ Left half - 0.5 rating */}
//                     <div
//                         className="absolute left-0 top-0 w-1/2 h-full z-10"
//                         onMouseEnter={() => setHoveredRating(star - 0.5)}
//                         onClick={() => setTempRating(star - 0.5)}
//                     />
//                     {/* ✅ Right half - full rating */}
//                     <div
//                         className="absolute right-0 top-0 w-1/2 h-full z-10"
//                         onMouseEnter={() => setHoveredRating(star)}
//                         onClick={() => setTempRating(star)}
//                     />
//                     <StarIcon
//                         filled={(hoveredRating || tempRating) >= star}
//                         half={
//                             !((hoveredRating || tempRating) >= star) &&
//                             (hoveredRating || tempRating) >= star - 0.5
//                         }
//                         size={size}
//                     />
//                 </div>
//             );
//         });
//     };
//
//     if (!recipe) {
//         return (
//             <div className="text-center py-16">
//                 <p className="text-xl text-gray-500 dark:text-gray-400">Recipe not found</p>
//             </div>
//         );
//     }
//
//     return (
//         <div className="w-full max-w-6xl mx-auto px-4 py-6">
//
//             {/* ✅ Top Bar: Back Button + Bookmark Button */}
//             <div className="flex items-center justify-between mb-6">
//                 <button
//                     onClick={onBack}
//                     className="flex items-center gap-2 px-4 py-2 text-blue-700 hover:text-[#004c86] font-medium transition duration-200 dark:text-white dark:hover:text-[#004c86]"
//                 >
//                     <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//                     </svg>
//                     Back to Recipes
//                 </button>
//
//                 {/* ✅ Bookmark Button */}
//                 <button
//                     onClick={onToggleBookmark}
//                     className={`flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold border-2 transition-all duration-200
//                         ${isBookmarked
//                         ? 'bg-yellow-400 border-yellow-400 text-white shadow-md'
//                         : 'bg-white border-gray-300 text-gray-600 hover:border-yellow-400 hover:text-yellow-500 dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-yellow-400'
//                     }`}
//                 >
//                     <svg
//                         className={`w-5 h-5 transition-all duration-200
//                             ${isBookmarked
//                             ? 'fill-white stroke-white'
//                             : 'fill-none stroke-current'
//                         }`}
//                         viewBox="0 0 24 24"
//                         strokeWidth={2}
//                     >
//                         <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
//                         />
//                     </svg>
//                     {isBookmarked ? 'Saved!' : 'Save Recipe'}
//                 </button>
//             </div>
//
//             {/* Recipe Card */}
//             <div className="bg-white rounded-2xl shadow-2xl overflow-hidden dark:bg-navy-800">
//
//                 {/* Hero Image */}
//                 <div className="relative w-full h-96 bg-gray-100 dark:bg-navy-700">
//                     <img
//                         className="w-full h-full object-cover"
//                         src={recipe.imageUrl !== null ? recipe.imageUrl : NoImageFound}
//                         alt={recipe.recipeName || 'Recipe'}
//                     />
//                     <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
//                     <div className="absolute top-6 right-6 bg-[#004c86] text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg dark:bg-white dark:text-gray-900">
//                         {recipe.categoryName || recipe.category}
//                     </div>
//                     <div className="absolute bottom-6 left-6 right-6">
//                         <h1 className="text-4xl md:text-3xl font-bold text-white mb-2 drop-shadow-lg">
//                             {recipe.recipeName || recipe.value}
//                         </h1>
//                     </div>
//                 </div>
//
//                 {/* Recipe Info Bar */}
//                 <div className="grid grid-cols-2 md:grid-cols-4 gap-4 p-6 bg-gray-50 border-b border-gray-200 dark:bg-navy-900 dark:border-navy-700">
//                     <div className="flex flex-col items-center text-center">
//                         <span className="text-3xl mb-2">🍽️</span>
//                         <span className="text-sm text-gray-600 dark:text-gray-400">Servings</span>
//                         <span className="text-lg font-bold text-navy-700 dark:text-white">{recipe.servings}</span>
//                     </div>
//                     {recipe.categoryName !== "Nutri Blender" && recipe.prepTime && (
//                         <div className="flex flex-col items-center text-center">
//                             <span className="text-3xl mb-2">⏱️</span>
//                             <span className="text-sm text-gray-600 dark:text-gray-400">Prep Time</span>
//                             <span className="text-lg font-bold text-navy-700 dark:text-white">{recipe.prepTime}</span>
//                         </div>
//                     )}
//                     <div className="flex flex-col items-center text-center">
//                         <span className="text-3xl mb-2">🔥</span>
//                         <span className="text-sm text-gray-600 dark:text-gray-400">Cook Time</span>
//                         <span className="text-lg font-bold text-navy-700 dark:text-white">{recipe.cookTime}</span>
//                     </div>
//                     {recipe.temperature !== null && (
//                         <div className="flex flex-col items-center text-center">
//                             <span className="text-3xl mb-2">🌡️</span>
//                             <span className="text-sm text-gray-600 dark:text-gray-400">Temperature</span>
//                             <span className="text-lg font-bold text-navy-700 dark:text-white">
//                                 {recipe.temperature}
//                             </span>
//                         </div>
//                     )}
//                 </div>
//
//                 {/* ✅ Rating Trigger Bar */}
//                 <div className="px-8 py-4 bg-white border-b border-gray-200 dark:bg-navy-800 dark:border-navy-700">
//                     {!hasRated ? (
//                         <div className="flex items-center justify-between">
//                             <div className="flex items-center gap-3">
//                                 <span className="text-2xl">⭐</span>
//                                 <div>
//                                     <p className="font-semibold text-navy-700 dark:text-white text-base">
//                                         Enjoyed this recipe?
//                                     </p>
//                                     <p className="text-sm text-gray-500 dark:text-gray-400">
//                                         Share your experience by rating it!
//                                     </p>
//                                 </div>
//                             </div>
//                             <button
//                                 onClick={() => setShowRatingCard(true)}
//                                 className="px-5 py-2.5 bg-[#004c86] text-white rounded-xl font-semibold hover:bg-blue-800 transition duration-200 shadow-md text-sm"
//                             >
//                                 Rate Now
//                             </button>
//                         </div>
//                     ) : (
//                         // ✅ Already rated - show stars + score
//                         <div className="flex items-center justify-between">
//                             <div className="flex items-center gap-3">
//                                 {/* ✅ Display half stars in trigger bar */}
//                                 <div className="flex items-center gap-0.5">
//                                     {renderStars(userRating, 'w-6 h-6', false)}
//                                 </div>
//                                 <span className="text-base font-bold text-navy-700 dark:text-white">
//                                     {userRating} / 5
//                                 </span>
//                             </div>
//                             <button
//                                 onClick={handleRemoveRating}
//                                 className="text-sm text-gray-400 hover:text-red-500 dark:text-gray-500 dark:hover:text-red-400 underline transition duration-200"
//                             >
//                                 Remove Rating
//                             </button>
//                         </div>
//                     )}
//                 </div>
//
//                 {/* ✅ Rating Card */}
//                 {showRatingCard && (
//                     <div className="px-8 py-8 bg-gradient-to-br from-gray-50 to-blue-50 border-b border-gray-200 dark:from-navy-900 dark:to-navy-800 dark:border-navy-700">
//                         <div className="max-w-md mx-auto bg-white dark:bg-navy-800 rounded-2xl shadow-xl p-8 border border-gray-100 dark:border-navy-700">
//
//                             {/* Header */}
//                             <div className="text-center mb-6">
//                                 <div className="text-5xl mb-3">⭐</div>
//                                 <h3 className="text-2xl font-bold text-navy-700 dark:text-white">
//                                     How was this recipe?
//                                 </h3>
//                                 <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
//                                     {recipe.recipeName}
//                                 </p>
//                             </div>
//
//                             {/* ✅ Large Interactive Half Stars */}
//                             <div className="flex items-center justify-center gap-2 mb-4">
//                                 {renderStars(0, 'w-14 h-14', true)}
//                             </div>
//
//                             {/* ✅ Score Display - No label, just number */}
//                             <div className="text-center mb-6 h-8">
//                                 {(hoveredRating > 0 || tempRating > 0) && (
//                                     <div className="flex items-center justify-center gap-2">
//                                         {/* ✅ Yellow Score Badge like the image */}
//                                         <div className="flex items-center gap-1.5 bg-yellow-400 text-gray-900 font-extrabold px-4 py-1.5 rounded-lg shadow-md">
//                                             <svg viewBox="0 0 24 24" className="w-4 h-4 fill-gray-900">
//                                                 <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
//                                             </svg>
//                                             <span className="text-xl">
//                                                 {(hoveredRating || tempRating).toFixed(1)}
//                                             </span>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//
//                             {/* ✅ Action Buttons */}
//                             <div className="flex gap-3">
//                                 <button
//                                     onClick={handleSkip}
//                                     className="flex-1 px-6 py-3 rounded-xl border-2 border-gray-300 text-gray-600 font-semibold hover:bg-gray-100 hover:border-gray-400 transition duration-200 dark:border-navy-600 dark:text-gray-400 dark:hover:bg-navy-700"
//                                 >
//                                     Skip
//                                 </button>
//                                 <button
//                                     onClick={handleSubmitRating}
//                                     disabled={tempRating === 0}
//                                     className={`flex-1 px-6 py-3 rounded-xl font-semibold transition duration-200 shadow-md
//                                         ${tempRating > 0
//                                         ? 'bg-[#004c86] text-white hover:bg-blue-800 cursor-pointer'
//                                         : 'bg-gray-200 text-gray-400 cursor-not-allowed dark:bg-navy-700 dark:text-gray-500'
//                                     }`}
//                                 >
//                                     Submit Rating
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//
//                 {/* ✅ Success Message */}
//                 {hasRated && (
//                     <div className="px-4 py-4 bg-green-50 border-b border-green-100 dark:bg-green-900/10 dark:border-green-900/30">
//                         <div className="flex items-center gap-1 max-w-md mx-auto">
//                             <span className="text-xl">🎉</span>
//                             <p className="text-sm font-medium text-green-700 dark:text-green-400">
//                                 Thanks for rating{' '}
//                                 <strong>"{recipe.recipeName}"</strong>!
//                             </p>
//                         </div>
//                     </div>
//                 )}
//
//                 {/* Tabs Navigation */}
//                 <div className="flex border-b border-gray-200 dark:border-navy-700">
//                     <button
//                         onClick={() => setActiveTab('ingredients')}
//                         className={`flex-1 px-6 py-4 text-lg font-semibold transition duration-200 ${
//                             activeTab === 'ingredients'
//                                 ? 'text-[#004c86] border-b-4 border-[#004c86] bg-blue-50 dark:text-white dark:border-[#004c86] dark:bg-navy-900'
//                                 : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-navy-900'
//                         }`}
//                     >
//                         📝 Ingredients
//                     </button>
//                     <button
//                         onClick={() => setActiveTab('steps')}
//                         className={`flex-1 px-6 py-4 text-lg font-semibold transition duration-200 ${
//                             activeTab === 'steps'
//                                 ? 'text-[#004c86] border-b-4 border-[#004c86] bg-blue-50 dark:text-white dark:border-[#004c86] dark:bg-navy-900'
//                                 : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-navy-900'
//                         }`}
//                     >
//                         👨‍🍳 Instructions
//                     </button>
//                 </div>
//
//                 {/* Tab Content */}
//                 <div className="p-8">
//
//                     {/* Ingredients Tab */}
//                     {activeTab === 'ingredients' && (
//                         <div className="animate-fadeIn">
//                             <h2 className="text-2xl font-bold text-navy-700 dark:text-white mb-6">
//                                 What You'll Need
//                             </h2>
//                             <div className="grid md:grid-cols-2 gap-4">
//                                 {recipe.ingredients && recipe.ingredients.length > 0 ? (
//                                     recipe.ingredients.map((ingredient, index) => (
//                                         <div
//                                             key={index}
//                                             className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition duration-200 dark:bg-navy-900 dark:hover:bg-navy-700"
//                                         >
//                                             <div className="flex-shrink-0 w-6 h-6 bg-[#004c86] text-white rounded-full flex items-center justify-center text-sm font-bold mt-0.5">
//                                                 {ingredient.displayOrder}
//                                             </div>
//                                             <div className="flex-1">
//                                                 <p className="text-base text-gray-800 dark:text-gray-200">
//                                                     {typeof ingredient === 'string' ? ingredient : (
//                                                         <>
//                                                             <span className="font-semibold">
//                                                                 {ingredient.quantity} {ingredient.unit}
//                                                             </span>{' '}
//                                                             {ingredient.ingredientName}
//                                                             {ingredient.note && (
//                                                                 <span className="text-sm text-gray-600 dark:text-gray-400">
//                                                                     {' '}({ingredient.note})
//                                                                 </span>
//                                                             )}
//                                                         </>
//                                                     )}
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     ))
//                                 ) : (
//                                     <p className="col-span-2 text-gray-500 dark:text-gray-400 text-center py-8">
//                                         No ingredients listed
//                                     </p>
//                                 )}
//                             </div>
//                         </div>
//                     )}
//
//                     {/* Steps Tab */}
//                     {activeTab === 'steps' && (
//                         <div className="animate-fadeIn">
//                             {recipe.chefTip && (
//                                 <div className="mt-2 mb-3 p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded dark:bg-yellow-900/20 dark:border-yellow-500">
//                                     <p className="text-sm text-yellow-800 dark:text-yellow-300">
//                                         💡 <span className="font-semibold">Tip:</span> {recipe.chefTip}
//                                     </p>
//                                 </div>
//                             )}
//                             <h2 className="text-2xl font-bold text-navy-700 dark:text-white mb-6">
//                                 Step-by-Step Instructions
//                             </h2>
//                             <div className="space-y-6">
//                                 {recipe.steps && recipe.steps.length > 0 ? (
//                                     recipe.steps.map((step, index) => (
//                                         <div
//                                             key={index}
//                                             className="flex gap-4 p-6 bg-gray-50 rounded-xl hover:shadow-md transition duration-200 dark:bg-navy-900"
//                                         >
//                                             <div className="flex-shrink-0">
//                                                 <div className="w-12 h-12 bg-[#004c86] text-white rounded-full flex items-center justify-center text-xl font-bold shadow-lg dark:bg-navy-600">
//                                                     {step.stepNumber || index + 1}
//                                                 </div>
//                                             </div>
//                                             <div className="flex-1">
//                                                 {step.title && (
//                                                     <h3 className="text-lg font-bold text-navy-700 dark:text-white mb-2">
//                                                         {step.title}
//                                                     </h3>
//                                                 )}
//                                                 <p className="text-base leading-relaxed text-gray-800 dark:text-gray-200">
//                                                     {typeof step === 'string' ? step : step.instruction}
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     ))
//                                 ) : (
//                                     <p className="text-gray-500 dark:text-gray-400 text-center py-8">
//                                         No instructions available
//                                     </p>
//                                 )}
//                             </div>
//                         </div>
//                     )}
//                 </div>
//
//                 {/* Chef's Notes */}
//                 {recipe.notes && (
//                     <div className="p-8 bg-blue-50 border-t border-blue-100 dark:bg-navy-900 dark:border-navy-700">
//                         <h3 className="text-xl font-bold text-navy-700 dark:text-white mb-3">
//                             📌 Chef's Notes
//                         </h3>
//                         <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
//                             {recipe.notes}
//                         </p>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };
//
// export default RecipeDetail;
//
// import React, { useState, useEffect } from 'react';
// import NoImageFound from "../../../../assets/img/nfts/no_image.png";
//
// const RATINGS_KEY = 'cromptonRecipeRatings';
// const COMMENTS_KEY = 'cromptonRecipeComments';
//
// const RecipeDetail = ({ recipe, onBack, isBookmarked, onToggleBookmark }) => {
//     const [activeTab, setActiveTab] = useState('ingredients');
//     const [userRating, setUserRating] = useState(0);
//     const [hoveredRating, setHoveredRating] = useState(0);
//     const [hasRated, setHasRated] = useState(false);
//     const [showRatingCard, setShowRatingCard] = useState(false);
//     const [tempRating, setTempRating] = useState(0);
//     const [isEditing, setIsEditing] = useState(false);
//
//     // ✅ Comment states
//     const [tempComment, setTempComment] = useState('');
//     const [userComment, setUserComment] = useState('');
//
//     // ✅ Load saved rating and comment
//     useEffect(() => {
//         if (recipe?.recipeId) {
//             try {
//                 // ✅ Load rating
//                 const stored = localStorage.getItem(RATINGS_KEY);
//                 if (stored) {
//                     const allRatings = JSON.parse(stored);
//                     if (allRatings[recipe.recipeId]) {
//                         setUserRating(allRatings[recipe.recipeId]);
//                         setHasRated(true);
//                         setShowRatingCard(false);
//                     } else {
//                         setUserRating(0);
//                         setHasRated(false);
//                         setShowRatingCard(false);
//                     }
//                 } else {
//                     setUserRating(0);
//                     setHasRated(false);
//                     setShowRatingCard(false);
//                 }
//
//                 // ✅ Load comment
//                 const storedComments = localStorage.getItem(COMMENTS_KEY);
//                 if (storedComments) {
//                     const allComments = JSON.parse(storedComments);
//                     if (allComments[recipe.recipeId]) {
//                         setUserComment(allComments[recipe.recipeId]);
//                     } else {
//                         setUserComment('');
//                     }
//                 } else {
//                     setUserComment('');
//                 }
//
//             } catch (error) {
//                 console.error('Error loading rating/comment:', error);
//             }
//         }
//     }, [recipe?.recipeId]);
//
//     // ✅ Submit rating and comment
//     const handleSubmitRating = () => {
//         if (tempRating === 0) return;
//         try {
//             // ✅ Save rating
//             const stored = localStorage.getItem(RATINGS_KEY);
//             const allRatings = stored ? JSON.parse(stored) : {};
//             allRatings[recipe.recipeId] = tempRating;
//             localStorage.setItem(RATINGS_KEY, JSON.stringify(allRatings));
//
//             // ✅ Save comment
//             const storedComments = localStorage.getItem(COMMENTS_KEY);
//             const allComments = storedComments ? JSON.parse(storedComments) : {};
//             allComments[recipe.recipeId] = tempComment.trim();
//             localStorage.setItem(COMMENTS_KEY, JSON.stringify(allComments));
//
//             setUserRating(tempRating);
//             setUserComment(tempComment.trim());
//             setHasRated(true);
//             setShowRatingCard(false);
//             setIsEditing(false);
//             setTempComment('');
//             setTempRating(0);
//             setHoveredRating(0);
//         } catch (error) {
//             console.error('Error saving rating/comment:', error);
//         }
//     };
//
//     // ✅ Handle edit — pre-fill existing rating and comment
//     const handleEditRating = () => {
//         setTempRating(userRating);
//         setTempComment(userComment);
//         setIsEditing(true);
//         setShowRatingCard(true);
//     };
//
//     // ✅ Skip rating
//     const handleSkip = () => {
//         setShowRatingCard(false);
//         setIsEditing(false);
//         setTempRating(0);
//         setTempComment('');
//         setHoveredRating(0);
//     };
//
//     // ✅ Remove rating and comment
//     const handleRemoveRating = () => {
//         try {
//             // ✅ Remove rating
//             const stored = localStorage.getItem(RATINGS_KEY);
//             if (stored) {
//                 const allRatings = JSON.parse(stored);
//                 delete allRatings[recipe.recipeId];
//                 localStorage.setItem(RATINGS_KEY, JSON.stringify(allRatings));
//             }
//
//             // ✅ Remove comment
//             const storedComments = localStorage.getItem(COMMENTS_KEY);
//             if (storedComments) {
//                 const allComments = JSON.parse(storedComments);
//                 delete allComments[recipe.recipeId];
//                 localStorage.setItem(COMMENTS_KEY, JSON.stringify(allComments));
//             }
//
//             setUserRating(0);
//             setTempRating(0);
//             setUserComment('');
//             setTempComment('');
//             setHasRated(false);
//             setHoveredRating(0);
//             setShowRatingCard(false);
//             setIsEditing(false);
//         } catch (error) {
//             console.error('Error removing rating/comment:', error);
//         }
//     };
//
//     // ✅ Half Star SVG Component
//     const StarIcon = ({ filled, half, size = 'w-14 h-14' }) => (
//         <svg
//             viewBox="0 0 24 24"
//             className={`${size} transition-all duration-150 drop-shadow-sm flex-shrink-0`}
//         >
//             {half ? (
//                 <>
//                     <path
//                         d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
//                         fill="#e5e7eb"
//                         stroke="#d1d5db"
//                         strokeWidth={0.5}
//                     />
//                     <clipPath id="left-half-clip">
//                         <rect x="0" y="0" width="12" height="24" />
//                     </clipPath>
//                     <path
//                         d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
//                         fill="#facc15"
//                         stroke="#facc15"
//                         strokeWidth={0.5}
//                         clipPath="url(#left-half-clip)"
//                     />
//                 </>
//             ) : filled ? (
//                 <path
//                     d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
//                     fill="#facc15"
//                     stroke="#facc15"
//                     strokeWidth={0.5}
//                 />
//             ) : (
//                 <path
//                     d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
//                     fill="#e5e7eb"
//                     stroke="#d1d5db"
//                     strokeWidth={0.5}
//                 />
//             )}
//         </svg>
//     );
//
//     // ✅ Render stars (supports 0.5 steps)
//     const renderStars = (rating, size = 'w-14 h-14', interactive = false) => {
//         return [1, 2, 3, 4, 5].map((star) => {
//             const isFull = rating >= star;
//             const isHalf = !isFull && rating >= star - 0.5;
//
//             if (!interactive) {
//                 return (
//                     <StarIcon
//                         key={star}
//                         filled={isFull}
//                         half={isHalf}
//                         size={size}
//                     />
//                 );
//             }
//
//             return (
//                 <div
//                     key={star}
//                     className="relative cursor-pointer hover:scale-125 transition-all duration-150"
//                     onMouseLeave={() => setHoveredRating(0)}
//                 >
//                     {/* Left half - 0.5 */}
//                     <div
//                         className="absolute left-0 top-0 w-1/2 h-full z-10"
//                         onMouseEnter={() => setHoveredRating(star - 0.5)}
//                         onClick={() => setTempRating(star - 0.5)}
//                     />
//                     {/* Right half - full */}
//                     <div
//                         className="absolute right-0 top-0 w-1/2 h-full z-10"
//                         onMouseEnter={() => setHoveredRating(star)}
//                         onClick={() => setTempRating(star)}
//                     />
//                     <StarIcon
//                         filled={(hoveredRating || tempRating) >= star}
//                         half={
//                             !((hoveredRating || tempRating) >= star) &&
//                             (hoveredRating || tempRating) >= star - 0.5
//                         }
//                         size={size}
//                     />
//                 </div>
//             );
//         });
//     };
//
//     if (!recipe) {
//         return (
//             <div className="text-center py-16">
//                 <p className="text-xl text-gray-500 dark:text-gray-400">Recipe not found</p>
//             </div>
//         );
//     }
//
//     return (
//         <div className="w-full max-w-6xl mx-auto px-2 sm:px-4 py-4 sm:py-6">
//
//             {/* ✅ Top Bar: Back + Bookmark */}
//             <div className="flex items-center justify-between mb-4 sm:mb-6 gap-2">
//
//                 {/* Back Button */}
//                 <button
//                     onClick={onBack}
//                     className="flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2 text-blue-700 hover:text-[#004c86] font-medium transition duration-200 dark:text-white dark:hover:text-[#004c86] text-sm sm:text-base"
//                 >
//                     <svg className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//                     </svg>
//                     <span className="hidden xs:inline sm:inline">Back to Recipes</span>
//                     <span className="inline xs:hidden sm:hidden">Back</span>
//                 </button>
//
//                 {/* ✅ Bookmark Button */}
//                 <button
//                     onClick={onToggleBookmark}
//                     className={`flex items-center gap-1.5 sm:gap-2 px-3 sm:px-5 py-2 sm:py-2.5 rounded-xl font-semibold border-2 transition-all duration-200 text-sm sm:text-base flex-shrink-0
//                         ${isBookmarked
//                         ? 'bg-yellow-400 border-yellow-400 text-white shadow-md'
//                         : 'bg-white border-gray-300 text-gray-600 hover:border-yellow-400 hover:text-yellow-500 dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-yellow-400'
//                     }`}
//                 >
//                     <svg
//                         className={`w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 transition-all duration-200
//                             ${isBookmarked
//                             ? 'fill-white stroke-white'
//                             : 'fill-none stroke-current'
//                         }`}
//                         viewBox="0 0 24 24"
//                         strokeWidth={2}
//                     >
//                         <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
//                         />
//                     </svg>
//                     <span>{isBookmarked ? 'Saved!' : 'Save Recipe'}</span>
//                 </button>
//             </div>
//
//             {/* ✅ Recipe Card */}
//             <div className="bg-white rounded-2xl shadow-2xl overflow-hidden dark:bg-navy-800">
//
//                 {/* ✅ Hero Image */}
//                 <div className="relative w-full h-48 sm:h-64 md:h-80 lg:h-96 bg-gray-100 dark:bg-navy-700">
//                     <img
//                         className="w-full h-full object-cover"
//                         src={recipe.imageUrl !== null ? recipe.imageUrl : NoImageFound}
//                         alt={recipe.recipeName || 'Recipe'}
//                     />
//                     <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
//
//                     {/* Category Badge */}
//                     <div className="absolute top-3 sm:top-6 right-3 sm:right-6 bg-[#004c86] text-white px-3 sm:px-4 py-1 sm:py-2 rounded-full text-xs sm:text-sm font-semibold shadow-lg dark:bg-white dark:text-gray-900 max-w-[45%] truncate">
//                         {recipe.categoryName || recipe.category}
//                     </div>
//
//                     {/* Recipe Title */}
//                     <div className="absolute bottom-3 sm:bottom-6 left-3 sm:left-6 right-3 sm:right-6">
//                         <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white drop-shadow-lg line-clamp-2">
//                             {recipe.recipeName || recipe.value}
//                         </h1>
//                     </div>
//                 </div>
//
//                 {/* ✅ Recipe Info Bar */}
//                 <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 p-4 sm:p-6 bg-gray-50 border-b border-gray-200 dark:bg-navy-900 dark:border-navy-700">
//                     <div className="flex flex-col items-center text-center p-2">
//                         <span className="text-2xl sm:text-3xl mb-1 sm:mb-2">🍽️</span>
//                         <span className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">Servings</span>
//                         <span className="text-base sm:text-lg font-bold text-navy-700 dark:text-white">{recipe.servings}</span>
//                     </div>
//                     {recipe.categoryName !== "Nutri Blender" && recipe.prepTime && (
//                         <div className="flex flex-col items-center text-center p-2">
//                             <span className="text-2xl sm:text-3xl mb-1 sm:mb-2">⏱️</span>
//                             <span className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">Prep Time</span>
//                             <span className="text-base sm:text-lg font-bold text-navy-700 dark:text-white">{recipe.prepTime}</span>
//                         </div>
//                     )}
//                     <div className="flex flex-col items-center text-center p-2">
//                         <span className="text-2xl sm:text-3xl mb-1 sm:mb-2">🔥</span>
//                         <span className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">Cook Time</span>
//                         <span className="text-base sm:text-lg font-bold text-navy-700 dark:text-white">{recipe.cookTime}</span>
//                     </div>
//                     {recipe.temperature !== null && (
//                         <div className="flex flex-col items-center text-center p-2">
//                             <span className="text-2xl sm:text-3xl mb-1 sm:mb-2">🌡️</span>
//                             <span className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">Temperature</span>
//                             <span className="text-base sm:text-lg font-bold text-navy-700 dark:text-white">{recipe.temperature}</span>
//                         </div>
//                     )}
//                 </div>
//
//                 {/* ✅ Rating Trigger Bar */}
//                 <div className="px-4 sm:px-8 py-3 sm:py-4 bg-white border-b border-gray-200 dark:bg-navy-800 dark:border-navy-700">
//                     {!hasRated ? (
//                         <div className="flex items-center justify-between gap-3">
//                             <div className="flex items-center gap-2 sm:gap-3 min-w-0">
//                                 <span className="text-xl sm:text-2xl flex-shrink-0">⭐</span>
//                                 <div className="min-w-0">
//                                     <p className="font-semibold text-navy-700 dark:text-white text-sm sm:text-base truncate">
//                                         Enjoyed this recipe?
//                                     </p>
//                                     <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 hidden sm:block">
//                                         Share your experience by rating it!
//                                     </p>
//                                 </div>
//                             </div>
//                             <button
//                                 onClick={() => setShowRatingCard(true)}
//                                 className="flex-shrink-0 px-3 sm:px-5 py-2 sm:py-2.5 bg-[#004c86] text-white rounded-xl font-semibold hover:bg-blue-800 transition duration-200 shadow-md text-xs sm:text-sm"
//                             >
//                                 Rate Now
//                             </button>
//                         </div>
//                     ) : (
//                         <div className="flex items-center justify-between gap-3">
//                             <div className="flex items-center gap-2 sm:gap-3 min-w-0">
//                                 <div className="flex items-center gap-0.5 flex-shrink-0">
//                                     {renderStars(userRating, 'w-4 h-4 sm:w-6 sm:h-6', false)}
//                                 </div>
//                                 <span className="text-sm sm:text-base font-bold text-navy-700 dark:text-white flex-shrink-0">
//                                     {userRating} / 5
//                                 </span>
//                             </div>
//                             {/* ✅ Edit + Remove buttons */}
//                             <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
//                                 <button
//                                     onClick={handleEditRating}
//                                     className="text-xs sm:text-sm text-[#004c86] hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 underline transition duration-200 font-semibold"
//                                 >
//                                     Edit
//                                 </button>
//                                 <span className="text-gray-300 dark:text-navy-600">|</span>
//                                 <button
//                                     onClick={handleRemoveRating}
//                                     className="text-xs sm:text-sm text-gray-400 hover:text-red-500 dark:text-gray-500 dark:hover:text-red-400 underline transition duration-200"
//                                 >
//                                     Remove
//                                 </button>
//                             </div>
//                         </div>
//                     )}
//                 </div>
//
//                 {/* ✅ Rating Card with Comment */}
//                 {showRatingCard && (
//                     <div className="px-3 sm:px-8 py-6 sm:py-8 bg-gradient-to-br from-gray-50 to-blue-50 border-b border-gray-200 dark:from-navy-900 dark:to-navy-800 dark:border-navy-700">
//                         <div className="max-w-xs sm:max-w-md mx-auto bg-white dark:bg-navy-800 rounded-2xl shadow-xl p-5 sm:p-8 border border-gray-100 dark:border-navy-700">
//
//                             {/* Header */}
//                             <div className="text-center mb-5 sm:mb-6">
//                                 <div className="text-4xl sm:text-5xl mb-2 sm:mb-3">
//                                     {isEditing ? '✏️' : '⭐'}
//                                 </div>
//                                 <h3 className="text-xl sm:text-2xl font-bold text-navy-700 dark:text-white">
//                                     {isEditing ? 'Edit Your Rating' : 'How was this recipe?'}
//                                 </h3>
//                                 <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-1 line-clamp-1">
//                                     {recipe.recipeName}
//                                 </p>
//                             </div>
//
//                             {/* ✅ Large Interactive Half Stars */}
//                             <div className="flex items-center justify-center gap-1 sm:gap-2 mb-4">
//                                 {renderStars(0, 'w-10 h-10 sm:w-14 sm:h-14', true)}
//                             </div>
//
//                             {/* ✅ Score Badge */}
//                             <div className="text-center mb-5 sm:mb-6 h-8 sm:h-9">
//                                 {(hoveredRating > 0 || tempRating > 0) && (
//                                     <div className="flex items-center justify-center">
//                                         <div className="flex items-center gap-1 sm:gap-1.5 bg-yellow-400 text-gray-900 font-extrabold px-3 sm:px-4 py-1 sm:py-1.5 rounded-lg shadow-md">
//                                             <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-4 sm:h-4 fill-gray-900 flex-shrink-0">
//                                                 <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
//                                             </svg>
//                                             <span className="text-lg sm:text-xl">
//                                                 {(hoveredRating || tempRating).toFixed(1)}
//                                             </span>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//
//                             {/* ✅ Divider */}
//                             <div className="border-t border-gray-100 dark:border-navy-700 mb-5 sm:mb-6"/>
//
//                             {/* ✅ Comment Section */}
//                             <div className="mb-5 sm:mb-6">
//                                 <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
//                                     💬 Your Comment
//                                     <span className="ml-1 text-xs font-normal text-gray-400 dark:text-gray-500">
//                                         (optional)
//                                     </span>
//                                 </label>
//                                 <textarea
//                                     value={tempComment}
//                                     onChange={(e) => {
//                                         if (e.target.value.length <= 300) {
//                                             setTempComment(e.target.value);
//                                         }
//                                     }}
//                                     placeholder="Share your thoughts about this recipe..."
//                                     rows={3}
//                                     className="w-full px-3 sm:px-4 py-2 sm:py-3 rounded-xl border-2 border-gray-200 dark:border-navy-600 focus:border-[#004c86] dark:focus:border-[#004c86] transition duration-200 dark:bg-navy-900 dark:text-white text-sm sm:text-base resize-none outline-none"
//                                 />
//                                 {/* ✅ Character Count */}
//                                 <div className="flex justify-end mt-1">
//                                     <span className={`text-xs ${
//                                         tempComment.length >= 280
//                                             ? 'text-red-400'
//                                             : 'text-gray-400 dark:text-gray-500'
//                                     }`}>
//                                         {tempComment.length}/300
//                                     </span>
//                                 </div>
//                             </div>
//
//                             {/* ✅ Action Buttons */}
//                             <div className="flex gap-2 sm:gap-3">
//                                 <button
//                                     onClick={handleSkip}
//                                     className="flex-1 px-4 sm:px-6 py-2.5 sm:py-3 rounded-xl border-2 border-gray-300 text-gray-600 font-semibold hover:bg-gray-100 hover:border-gray-400 transition duration-200 dark:border-navy-600 dark:text-gray-400 dark:hover:bg-navy-700 text-sm sm:text-base"
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     onClick={handleSubmitRating}
//                                     disabled={tempRating === 0}
//                                     className={`flex-1 px-4 sm:px-6 py-2.5 sm:py-3 rounded-xl font-semibold transition duration-200 shadow-md text-sm sm:text-base
//                                         ${tempRating > 0
//                                         ? 'bg-[#004c86] text-white hover:bg-blue-800 cursor-pointer'
//                                         : 'bg-gray-200 text-gray-400 cursor-not-allowed dark:bg-navy-700 dark:text-gray-500'
//                                     }`}
//                                 >
//                                     {isEditing ? 'Update Rating' : 'Submit Rating'}
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//
//                 {/* ✅ Your Rating & Comment Display Card */}
//                 {hasRated && !showRatingCard && (
//                     <div className="px-4 sm:px-8 py-5 sm:py-6 bg-gradient-to-br from-blue-50 to-indigo-50 border-b border-blue-100 dark:from-navy-900 dark:to-navy-800 dark:border-navy-700">
//                         <div className="max-w-2xl mx-auto">
//
//                             {/* ✅ Card Header */}
//                             <div className="flex items-center justify-between mb-4">
//                                 <h3 className="text-base sm:text-lg font-bold text-navy-700 dark:text-white flex items-center gap-2">
//                                     <span>📝</span>
//                                     Your Review
//                                 </h3>
//                                 {/* ✅ Edit Button */}
//                                 <button
//                                     onClick={handleEditRating}
//                                     className="flex items-center gap-1.5 px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg border-2 border-[#004c86] text-[#004c86] hover:bg-[#004c86] hover:text-white transition duration-200 text-xs sm:text-sm font-semibold dark:border-blue-400 dark:text-blue-400 dark:hover:bg-blue-400 dark:hover:text-white"
//                                 >
//                                     <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
//                                     </svg>
//                                     Edit Review
//                                 </button>
//                             </div>
//
//                             {/* ✅ Review Card */}
//                             <div className="bg-white dark:bg-navy-800 rounded-xl shadow-md p-4 sm:p-6 border border-blue-100 dark:border-navy-700">
//
//                                 {/* ✅ Stars + Score */}
//                                 <div className="flex items-center gap-3 mb-3 sm:mb-4">
//                                     <div className="flex items-center gap-0.5">
//                                         {renderStars(userRating, 'w-5 h-5 sm:w-7 sm:h-7', false)}
//                                     </div>
//                                     <div className="flex items-center gap-1 bg-yellow-400 text-gray-900 font-bold px-2 sm:px-3 py-0.5 sm:py-1 rounded-lg text-xs sm:text-sm">
//                                         <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-3.5 sm:h-3.5 fill-gray-900 flex-shrink-0">
//                                             <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
//                                         </svg>
//                                         <span>{userRating.toFixed(1)} / 5</span>
//                                     </div>
//                                 </div>
//
//                                 {/* ✅ Comment or No Comment placeholder */}
//                                 {userComment ? (
//                                     <div className="bg-gray-50 dark:bg-navy-900 rounded-lg p-3 sm:p-4 border border-gray-100 dark:border-navy-700">
//                                         <p className="text-sm sm:text-base text-gray-700 dark:text-gray-300 leading-relaxed italic">
//                                             💬 "{userComment}"
//                                         </p>
//                                     </div>
//                                 ) : (
//                                     <div className="bg-gray-50 dark:bg-navy-900 rounded-lg p-3 sm:p-4 border border-dashed border-gray-200 dark:border-navy-600">
//                                         <p className="text-xs sm:text-sm text-gray-400 dark:text-gray-500 italic text-center">
//                                             No comment added.{' '}
//                                             <button
//                                                 onClick={handleEditRating}
//                                                 className="text-[#004c86] dark:text-blue-400 underline font-medium hover:text-blue-800 transition duration-200"
//                                             >
//                                                 Add one?
//                                             </button>
//                                         </p>
//                                     </div>
//                                 )}
//
//                                 {/* ✅ Remove Button */}
//                                 <div className="flex justify-end mt-3 sm:mt-4">
//                                     <button
//                                         onClick={handleRemoveRating}
//                                         className="flex items-center gap-1.5 text-xs sm:text-sm text-gray-400 hover:text-red-500 dark:text-gray-500 dark:hover:text-red-400 transition duration-200"
//                                     >
//                                         <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                                         </svg>
//                                         Remove Review
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//
//                 {/* ✅ Tabs Navigation */}
//                 <div className="flex border-b border-gray-200 dark:border-navy-700">
//                     <button
//                         onClick={() => setActiveTab('ingredients')}
//                         className={`flex-1 px-3 sm:px-6 py-3 sm:py-4 text-sm sm:text-lg font-semibold transition duration-200 ${
//                             activeTab === 'ingredients'
//                                 ? 'text-[#004c86] border-b-4 border-[#004c86] bg-blue-50 dark:text-white dark:border-[#004c86] dark:bg-navy-900'
//                                 : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-navy-900'
//                         }`}
//                     >
//                         📝 <span className="hidden sm:inline">Ingredients</span>
//                         <span className="inline sm:hidden">Ingredients</span>
//                     </button>
//                     <button
//                         onClick={() => setActiveTab('steps')}
//                         className={`flex-1 px-3 sm:px-6 py-3 sm:py-4 text-sm sm:text-lg font-semibold transition duration-200 ${
//                             activeTab === 'steps'
//                                 ? 'text-[#004c86] border-b-4 border-[#004c86] bg-blue-50 dark:text-white dark:border-[#004c86] dark:bg-navy-900'
//                                 : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-navy-900'
//                         }`}
//                     >
//                         👨‍🍳 <span className="hidden sm:inline">Instructions</span>
//                         <span className="inline sm:hidden">Instructions</span>
//                     </button>
//                 </div>
//
//                 {/* ✅ Tab Content */}
//                 <div className="p-4 sm:p-6 md:p-8">
//
//                     {/* Ingredients Tab */}
//                     {activeTab === 'ingredients' && (
//                         <div className="animate-fadeIn">
//                             <h2 className="text-xl sm:text-2xl font-bold text-navy-700 dark:text-white mb-4 sm:mb-6">
//                                 What You'll Need
//                             </h2>
//                             <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
//                                 {recipe.ingredients && recipe.ingredients.length > 0 ? (
//                                     recipe.ingredients.map((ingredient, index) => (
//                                         <div
//                                             key={index}
//                                             className="flex items-start gap-3 p-3 sm:p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition duration-200 dark:bg-navy-900 dark:hover:bg-navy-700"
//                                         >
//                                             <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 bg-[#004c86] text-white rounded-full flex items-center justify-center text-xs sm:text-sm font-bold mt-0.5">
//                                                 {ingredient.displayOrder}
//                                             </div>
//                                             <div className="flex-1 min-w-0">
//                                                 <p className="text-sm sm:text-base text-gray-800 dark:text-gray-200">
//                                                     {typeof ingredient === 'string' ? ingredient : (
//                                                         <>
//                                                             <span className="font-semibold">
//                                                                 {ingredient.quantity} {ingredient.unit}
//                                                             </span>{' '}
//                                                             {ingredient.ingredientName}
//                                                             {ingredient.note && (
//                                                                 <span className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
//                                                                     {' '}({ingredient.note})
//                                                                 </span>
//                                                             )}
//                                                         </>
//                                                     )}
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     ))
//                                 ) : (
//                                     <p className="col-span-2 text-gray-500 dark:text-gray-400 text-center py-8">
//                                         No ingredients listed
//                                     </p>
//                                 )}
//                             </div>
//                         </div>
//                     )}
//
//                     {/* Steps Tab */}
//                     {activeTab === 'steps' && (
//                         <div className="animate-fadeIn">
//                             {recipe.chefTip && (
//                                 <div className="mt-2 mb-3 p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded dark:bg-yellow-900/20 dark:border-yellow-500">
//                                     <p className="text-xs sm:text-sm text-yellow-800 dark:text-yellow-300">
//                                         💡 <span className="font-semibold">Tip:</span> {recipe.chefTip}
//                                     </p>
//                                 </div>
//                             )}
//                             <h2 className="text-xl sm:text-2xl font-bold text-navy-700 dark:text-white mb-4 sm:mb-6">
//                                 Step-by-Step Instructions
//                             </h2>
//                             <div className="space-y-4 sm:space-y-6">
//                                 {recipe.steps && recipe.steps.length > 0 ? (
//                                     recipe.steps.map((step, index) => (
//                                         <div
//                                             key={index}
//                                             className="flex gap-3 sm:gap-4 p-4 sm:p-6 bg-gray-50 rounded-xl hover:shadow-md transition duration-200 dark:bg-navy-900"
//                                         >
//                                             <div className="flex-shrink-0">
//                                                 <div className="w-9 h-9 sm:w-12 sm:h-12 bg-[#004c86] text-white rounded-full flex items-center justify-center text-base sm:text-xl font-bold shadow-lg dark:bg-navy-600">
//                                                     {step.stepNumber || index + 1}
//                                                 </div>
//                                             </div>
//                                             <div className="flex-1 min-w-0">
//                                                 {step.title && (
//                                                     <h3 className="text-base sm:text-lg font-bold text-navy-700 dark:text-white mb-1 sm:mb-2">
//                                                         {step.title}
//                                                     </h3>
//                                                 )}
//                                                 <p className="text-sm sm:text-base leading-relaxed text-gray-800 dark:text-gray-200">
//                                                     {typeof step === 'string' ? step : step.instruction}
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     ))
//                                 ) : (
//                                     <p className="text-gray-500 dark:text-gray-400 text-center py-8">
//                                         No instructions available
//                                     </p>
//                                 )}
//                             </div>
//                         </div>
//                     )}
//                 </div>
//
//                 {/* ✅ Chef's Notes */}
//                 {recipe.notes && (
//                     <div className="p-4 sm:p-6 md:p-8 bg-blue-50 border-t border-blue-100 dark:bg-navy-900 dark:border-navy-700">
//                         <h3 className="text-lg sm:text-xl font-bold text-navy-700 dark:text-white mb-2 sm:mb-3">
//                             📌 Chef's Notes
//                         </h3>
//                         <p className="text-sm sm:text-base text-gray-700 dark:text-gray-300 leading-relaxed">
//                             {recipe.notes}
//                         </p>
//                     </div>
//                 )}
//
//             </div>
//         </div>
//     );
// };
//
// export default RecipeDetail;

import React, { useState, useEffect } from 'react';
import NoImageFound from "../../../../assets/img/nfts/no_image.png";
import axios from "axios";
import { AES, enc } from "crypto-js";
import { useUserAuth } from "../../../../context/UserAuthContext";

const RecipeDetail = ({ recipe, onBack, isBookmarked, onToggleBookmark }) => {
    const [activeTab, setActiveTab] = useState('ingredients');
    const [userRating, setUserRating] = useState(0);
    const [hoveredRating, setHoveredRating] = useState(0);
    const [hasRated, setHasRated] = useState(false);
    const [showRatingCard, setShowRatingCard] = useState(false);
    const [tempRating, setTempRating] = useState(0);
    const [showUpdateSection, setShowUpdateSection] = useState(false);

    // ✅ Comment states
    const [tempComment, setTempComment] = useState('');
    const [userComment, setUserComment] = useState('');

    // ✅ API states
    const [isSubmittingRating, setIsSubmittingRating] = useState(false);
    const [ratingError, setRatingError] = useState('');
    const [ratingSuccess, setRatingSuccess] = useState(false);

    const secretKey = "cromptonssecretkey";
    const BASE_URL = process.env.REACT_APP_CROMPTON_SENZE_RECIPE_URL;
    let { Token } = useUserAuth();
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);

    // ===== FETCH MY RATINGS ON MOUNT =====
    useEffect(() => {
        if (recipe?.recipeId) {
            fetchMyRatings();
        }
    }, [recipe?.recipeId]);

    // ===== FETCH MY RATINGS API =====
    const fetchMyRatings = async () => {
        try {
            const response = await axios.get(
                BASE_URL + "recipes/my-ratings",
                {
                    headers: {
                        'Authorization': decryptedValue
                    }
                }
            );

            if (response.status === 200 && response.data?.recipes) {
                const currentRecipeRating = response.data.recipes.find(
                    r => r.recipeId === recipe.recipeId
                );

                if (currentRecipeRating) {
                    setUserRating(currentRecipeRating.userRating);
                    setUserComment(currentRecipeRating.userComment || '');
                    setHasRated(true);
                } else {
                    setUserRating(0);
                    setUserComment('');
                    setHasRated(false);
                }
            }
        } catch (error) {
            console.error('Error fetching ratings:', error);
        }
    };

    // ===== POST RATING API =====
    const handleSubmitRating = async () => {
        if (tempRating === 0) return;

        setIsSubmittingRating(true);
        setRatingError('');
        setRatingSuccess(false);

        try {
            const response = await axios.post(
                BASE_URL + `recipes/${recipe.recipeId}/rating`,
                {
                    rating: tempRating,
                    comment: tempComment.trim() || null
                },
                {
                    headers: {
                        'Authorization': decryptedValue,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.status === 200 || response.status === 201) {
                setUserRating(tempRating);
                setUserComment(tempComment.trim());
                setHasRated(true);
                setShowRatingCard(false);
                setShowUpdateSection(false);
                setTempComment('');
                setTempRating(0);
                setHoveredRating(0);
                setRatingSuccess(true);

                await fetchMyRatings();

                setTimeout(() => {
                    setRatingSuccess(false);
                }, 3000);
            }
        } catch (error) {
            console.error('Error submitting rating:', error);
            setRatingError(
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to submit rating. Please try again.'
            );
        } finally {
            setIsSubmittingRating(false);
        }
    };

    // ✅ Handle Update click
    const handleUpdateClick = () => {
        setTempRating(userRating);
        setTempComment(userComment);
        setShowUpdateSection(true);
        setRatingError('');
    };

    // ✅ Cancel update
    const handleCancelUpdate = () => {
        setShowUpdateSection(false);
        setShowRatingCard(false);
        setTempRating(0);
        setTempComment('');
        setHoveredRating(0);
        setRatingError('');
    };

    // ✅ Skip rating
    const handleSkip = () => {
        setShowRatingCard(false);
        setShowUpdateSection(false);
        setTempRating(0);
        setTempComment('');
        setHoveredRating(0);
        setRatingError('');
    };

    // ✅ Half Star SVG Component
    const StarIcon = ({ filled, half, size = 'w-14 h-14' }) => (
        <svg
            viewBox="0 0 24 24"
            className={`${size} transition-all duration-150 drop-shadow-sm flex-shrink-0`}
        >
            {half ? (
                <>
                    <path
                        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                        fill="#e5e7eb"
                        stroke="#d1d5db"
                        strokeWidth={0.5}
                    />
                    <clipPath id="left-half-clip">
                        <rect x="0" y="0" width="12" height="24" />
                    </clipPath>
                    <path
                        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                        fill="#facc15"
                        stroke="#facc15"
                        strokeWidth={0.5}
                        clipPath="url(#left-half-clip)"
                    />
                </>
            ) : filled ? (
                <path
                    d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                    fill="#facc15"
                    stroke="#facc15"
                    strokeWidth={0.5}
                />
            ) : (
                <path
                    d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                    fill="#e5e7eb"
                    stroke="#d1d5db"
                    strokeWidth={0.5}
                />
            )}
        </svg>
    );

    // ✅ Render stars (supports 0.5 steps)
    const renderStars = (rating, size = 'w-14 h-14', interactive = false) => {
        return [1, 2, 3, 4, 5].map((star) => {
            const isFull = rating >= star;
            const isHalf = !isFull && rating >= star - 0.5;

            if (!interactive) {
                return (
                    <StarIcon
                        key={star}
                        filled={isFull}
                        half={isHalf}
                        size={size}
                    />
                );
            }

            return (
                <div
                    key={star}
                    className="relative cursor-pointer hover:scale-125 transition-all duration-150"
                    onMouseLeave={() => setHoveredRating(0)}
                >
                    <div
                        className="absolute left-0 top-0 w-1/2 h-full z-10"
                        onMouseEnter={() => setHoveredRating(star - 0.5)}
                        onClick={() => setTempRating(star - 0.5)}
                    />
                    <div
                        className="absolute right-0 top-0 w-1/2 h-full z-10"
                        onMouseEnter={() => setHoveredRating(star)}
                        onClick={() => setTempRating(star)}
                    />
                    <StarIcon
                        filled={(hoveredRating || tempRating) >= star}
                        half={
                            !((hoveredRating || tempRating) >= star) &&
                            (hoveredRating || tempRating) >= star - 0.5
                        }
                        size={size}
                    />
                </div>
            );
        });
    };

    if (!recipe) {
        return (
            <div className="text-center py-16">
                <p className="text-xl text-gray-500 dark:text-gray-400">Recipe not found</p>
            </div>
        );
    }

    return (
        <div className="w-full max-w-6xl mx-auto px-2 sm:px-4 py-4 sm:py-6">

            {/* ✅ Top Bar: Back + Bookmark */}
            <div className="flex items-center justify-between mb-4 sm:mb-6 gap-2">
                <button
                    onClick={onBack}
                    className="flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2 text-blue-700 hover:text-[#004c86] font-medium transition duration-200 dark:text-white dark:hover:text-[#004c86] text-sm sm:text-base"
                >
                    <svg className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                    <span className="hidden xs:inline sm:inline">Back to Recipes</span>
                    <span className="inline xs:hidden sm:hidden">Back</span>
                </button>

                {/* ✅ Bookmark Button */}
                <button
                    onClick={onToggleBookmark}
                    className={`flex items-center gap-1.5 sm:gap-2 px-3 sm:px-5 py-2 sm:py-2.5 rounded-xl font-semibold border-2 transition-all duration-200 text-sm sm:text-base flex-shrink-0
                        ${isBookmarked
                        ? 'bg-yellow-400 border-yellow-400 text-white shadow-md'
                        : 'bg-white border-gray-300 text-gray-600 hover:border-yellow-400 hover:text-yellow-500 dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-yellow-400'
                    }`}
                >
                    <svg
                        className={`w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 transition-all duration-200
                            ${isBookmarked
                            ? 'fill-white stroke-white'
                            : 'fill-none stroke-current'
                        }`}
                        viewBox="0 0 24 24"
                        strokeWidth={2}
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
                        />
                    </svg>
                    <span>{isBookmarked ? 'Saved!' : 'Save Recipe'}</span>
                </button>
            </div>

            {/* ✅ Recipe Card */}
            <div className="bg-white rounded-2xl shadow-2xl overflow-hidden dark:bg-navy-800">

                {/* ✅ Hero Image */}
                <div className="relative w-full h-48 sm:h-64 md:h-80 lg:h-96 bg-gray-100 dark:bg-navy-700">
                    <img
                        className="w-full h-full object-cover"
                        src={recipe.imageUrl !== null ? recipe.imageUrl : NoImageFound}
                        alt={recipe.recipeName || 'Recipe'}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                    {/* Category Badge */}
                    <div className="absolute top-3 sm:top-6 right-3 sm:right-6 bg-[#004c86] text-white px-3 sm:px-4 py-1 sm:py-2 rounded-full text-xs sm:text-sm font-semibold shadow-lg dark:bg-white dark:text-gray-900 max-w-[45%] truncate">
                        {recipe.categoryName || recipe.category}
                    </div>

                    {/* Recipe Title */}
                    <div className="absolute bottom-3 sm:bottom-6 left-3 sm:left-6 right-3 sm:right-6">
                        <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white drop-shadow-lg line-clamp-2">
                            {recipe.recipeName || recipe.value}
                        </h1>
                    </div>
                </div>

                {/* ✅ Recipe Info Bar */}
                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 p-4 sm:p-6 bg-gray-50 border-b border-gray-200 dark:bg-navy-900 dark:border-navy-700">
                    <div className="flex flex-col items-center text-center p-2">
                        <span className="text-2xl sm:text-3xl mb-1 sm:mb-2">🍽️</span>
                        <span className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">Servings</span>
                        <span className="text-base sm:text-lg font-bold text-navy-700 dark:text-white">{recipe.servings}</span>
                    </div>
                    {recipe.categoryName !== "Nutri Blender" && recipe.prepTime && (
                        <div className="flex flex-col items-center text-center p-2">
                            <span className="text-2xl sm:text-3xl mb-1 sm:mb-2">⏱️</span>
                            <span className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">Prep Time</span>
                            <span className="text-base sm:text-lg font-bold text-navy-700 dark:text-white">{recipe.prepTime}</span>
                        </div>
                    )}
                    <div className="flex flex-col items-center text-center p-2">
                        <span className="text-2xl sm:text-3xl mb-1 sm:mb-2">🔥</span>
                        <span className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">Cook Time</span>
                        <span className="text-base sm:text-lg font-bold text-navy-700 dark:text-white">{recipe.cookTime}</span>
                    </div>
                    {recipe.temperature !== null && (
                        <div className="flex flex-col items-center text-center p-2">
                            <span className="text-2xl sm:text-3xl mb-1 sm:mb-2">🌡️</span>
                            <span className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">Temperature</span>
                            <span className="text-base sm:text-lg font-bold text-navy-700 dark:text-white">{recipe.temperature}</span>
                        </div>
                    )}
                </div>

                {/* ✅ Rating Section */}
                <div className="border-b border-gray-200 dark:border-navy-700">

                    {/* ✅ Rating Trigger Bar */}
                    <div className="px-4 sm:px-8 py-3 sm:py-4 bg-white dark:bg-navy-800">
                        {!hasRated ? (
                            <div className="flex items-center justify-between gap-3">
                                <div className="flex items-center gap-2 sm:gap-3 min-w-0">
                                    <span className="text-xl sm:text-2xl flex-shrink-0">⭐</span>
                                    <div className="min-w-0">
                                        <p className="font-semibold text-navy-700 dark:text-white text-sm sm:text-base truncate">
                                            Enjoyed this recipe?
                                        </p>
                                        <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 hidden sm:block">
                                            Share your experience by rating it!
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => {
                                        setShowRatingCard(true);
                                        setShowUpdateSection(false);
                                    }}
                                    className="flex-shrink-0 px-3 sm:px-5 py-2 sm:py-2.5 bg-[#004c86] text-white rounded-xl font-semibold hover:bg-blue-800 transition duration-200 shadow-md text-xs sm:text-sm"
                                >
                                    Rate Now
                                </button>
                            </div>
                        ) : (
                            // ✅ Compact review display — Stars + Comment + Update button
                            <div className="flex items-center justify-between gap-3">
                                <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">

                                    {/* ✅ Stars only — no score badge */}
                                    <div className="flex items-center gap-0.5 flex-shrink-0">
                                        {renderStars(userRating, 'w-4 h-4 sm:w-5 sm:h-5', false)}
                                    </div>

                                    {/* ✅ Comment preview — shown if exists */}
                                    {userComment && (
                                        <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 italic truncate">
                                            💬 "{userComment}"
                                        </p>
                                    )}
                                </div>

                                {/* ✅ Update Button */}
                                <button
                                    onClick={handleUpdateClick}
                                    className="flex-shrink-0 flex items-center gap-1.5 px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg border-2 border-[#004c86] text-[#004c86] hover:bg-[#004c86] hover:text-white transition duration-200 text-xs sm:text-sm font-semibold dark:border-blue-400 dark:text-blue-400 dark:hover:bg-blue-400 dark:hover:text-white"
                                >
                                    <svg className="w-3 h-3 sm:w-3.5 sm:h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                    </svg>
                                    Update
                                </button>
                            </div>
                        )}
                    </div>

                    {/* ✅ Rate Now Card */}
                    {showRatingCard && !hasRated && (
                        <div className="px-3 sm:px-8 py-6 sm:py-8 bg-gradient-to-br from-gray-50 to-blue-50 dark:from-navy-900 dark:to-navy-800">
                            <div className="max-w-xs sm:max-w-md mx-auto bg-white dark:bg-navy-800 rounded-2xl shadow-xl p-5 sm:p-8 border border-gray-100 dark:border-navy-700">

                                {/* Header */}
                                <div className="text-center mb-5 sm:mb-6">
                                    <div className="text-4xl sm:text-5xl mb-2 sm:mb-3">⭐</div>
                                    <h3 className="text-xl sm:text-2xl font-bold text-navy-700 dark:text-white">
                                        How was this recipe?
                                    </h3>
                                    <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-1 line-clamp-1">
                                        {recipe.recipeName}
                                    </p>
                                </div>

                                {/* ✅ Interactive Stars */}
                                <div className="flex items-center justify-center gap-1 sm:gap-2 mb-4">
                                    {renderStars(0, 'w-10 h-10 sm:w-14 sm:h-14', true)}
                                </div>

                                {/* ✅ Score Badge */}
                                <div className="text-center mb-5 sm:mb-6 h-8 sm:h-9">
                                    {(hoveredRating > 0 || tempRating > 0) && (
                                        <div className="flex items-center justify-center">
                                            <div className="flex items-center gap-1 sm:gap-1.5 bg-yellow-400 text-gray-900 font-extrabold px-3 sm:px-4 py-1 sm:py-1.5 rounded-lg shadow-md">
                                                <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-4 sm:h-4 fill-gray-900 flex-shrink-0">
                                                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                                </svg>
                                                <span className="text-lg sm:text-xl">
                                                    {(hoveredRating || tempRating).toFixed(1)}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* ✅ Divider */}
                                <div className="border-t border-gray-100 dark:border-navy-700 mb-5 sm:mb-6"/>

                                {/* ✅ Comment Section */}
                                <div className="mb-5 sm:mb-6">
                                    <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                                        💬 Your Comment
                                        <span className="ml-1 text-xs font-normal text-gray-400 dark:text-gray-500">
                                            (optional)
                                        </span>
                                    </label>
                                    <textarea
                                        value={tempComment}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 300) {
                                                setTempComment(e.target.value);
                                            }
                                        }}
                                        placeholder="Share your thoughts about this recipe..."
                                        rows={3}
                                        className="w-full px-3 sm:px-4 py-2 sm:py-3 rounded-xl border-2 border-gray-200 dark:border-navy-600 focus:border-[#004c86] dark:focus:border-[#004c86] transition duration-200 dark:bg-navy-900 dark:text-white text-sm sm:text-base resize-none outline-none"
                                    />
                                    <div className="flex justify-end mt-1">
                                        <span className={`text-xs ${
                                            tempComment.length >= 280
                                                ? 'text-red-400'
                                                : 'text-gray-400 dark:text-gray-500'
                                        }`}>
                                            {tempComment.length}/300
                                        </span>
                                    </div>
                                </div>

                                {/* ✅ API Error */}
                                {ratingError && (
                                    <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                                        <p className="text-xs sm:text-sm text-red-600">⚠️ {ratingError}</p>
                                    </div>
                                )}

                                {/* ✅ Action Buttons */}
                                <div className="flex gap-2 sm:gap-3">
                                    <button
                                        onClick={handleSkip}
                                        disabled={isSubmittingRating}
                                        className="flex-1 px-4 sm:px-6 py-2.5 sm:py-3 rounded-xl border-2 border-gray-300 text-gray-600 font-semibold hover:bg-gray-100 hover:border-gray-400 transition duration-200 dark:border-navy-600 dark:text-gray-400 dark:hover:bg-navy-700 text-sm sm:text-base"
                                    >
                                        Skip
                                    </button>
                                    <button
                                        onClick={handleSubmitRating}
                                        disabled={tempRating === 0 || isSubmittingRating}
                                        className={`flex-1 px-4 sm:px-6 py-2.5 sm:py-3 rounded-xl font-semibold transition duration-200 shadow-md text-sm sm:text-base flex items-center justify-center gap-2
                                            ${tempRating > 0 && !isSubmittingRating
                                            ? 'bg-[#004c86] text-white hover:bg-blue-800 cursor-pointer'
                                            : 'bg-gray-200 text-gray-400 cursor-not-allowed dark:bg-navy-700 dark:text-gray-500'
                                        }`}
                                    >
                                        {isSubmittingRating ? (
                                            <>
                                                <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
                                                </svg>
                                                Submitting...
                                            </>
                                        ) : (
                                            'Submit Rating'
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* ✅ Update Section */}
                    {showUpdateSection && hasRated && (
                        <div className="px-3 sm:px-8 py-6 sm:py-8 bg-gradient-to-br from-gray-50 to-blue-50 dark:from-navy-900 dark:to-navy-800">
                            <div className="max-w-xs sm:max-w-md mx-auto bg-white dark:bg-navy-800 rounded-2xl shadow-xl p-5 sm:p-8 border border-gray-100 dark:border-navy-700">

                                {/* Header */}
                                <div className="text-center mb-5 sm:mb-6">
                                    <div className="text-4xl sm:text-5xl mb-2 sm:mb-3">✏️</div>
                                    <h3 className="text-xl sm:text-2xl font-bold text-navy-700 dark:text-white">
                                        Update Your Rating
                                    </h3>
                                    <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-1 line-clamp-1">
                                        {recipe.recipeName}
                                    </p>
                                </div>

                                {/* ✅ Interactive Stars */}
                                <div className="flex items-center justify-center gap-1 sm:gap-2 mb-4">
                                    {renderStars(0, 'w-10 h-10 sm:w-14 sm:h-14', true)}
                                </div>

                                {/* ✅ Score Badge */}
                                <div className="text-center mb-5 sm:mb-6 h-8 sm:h-9">
                                    {(hoveredRating > 0 || tempRating > 0) && (
                                        <div className="flex items-center justify-center">
                                            <div className="flex items-center gap-1 sm:gap-1.5 bg-yellow-400 text-gray-900 font-extrabold px-3 sm:px-4 py-1 sm:py-1.5 rounded-lg shadow-md">
                                                <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-4 sm:h-4 fill-gray-900 flex-shrink-0">
                                                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                                </svg>
                                                <span className="text-lg sm:text-xl">
                                                    {(hoveredRating || tempRating).toFixed(1)}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* ✅ Divider */}
                                <div className="border-t border-gray-100 dark:border-navy-700 mb-5 sm:mb-6"/>

                                {/* ✅ Comment Section */}
                                <div className="mb-5 sm:mb-6">
                                    <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                                        💬 Your Comment
                                        <span className="ml-1 text-xs font-normal text-gray-400 dark:text-gray-500">
                                            (optional)
                                        </span>
                                    </label>
                                    <textarea
                                        value={tempComment}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 300) {
                                                setTempComment(e.target.value);
                                            }
                                        }}
                                        placeholder="Update your thoughts about this recipe..."
                                        rows={3}
                                        className="w-full px-3 sm:px-4 py-2 sm:py-3 rounded-xl border-2 border-gray-200 dark:border-navy-600 focus:border-[#004c86] dark:focus:border-[#004c86] transition duration-200 dark:bg-navy-900 dark:text-white text-sm sm:text-base resize-none outline-none"
                                    />
                                    <div className="flex justify-end mt-1">
                                        <span className={`text-xs ${
                                            tempComment.length >= 280
                                                ? 'text-red-400'
                                                : 'text-gray-400 dark:text-gray-500'
                                        }`}>
                                            {tempComment.length}/300
                                        </span>
                                    </div>
                                </div>

                                {/* ✅ API Error */}
                                {ratingError && (
                                    <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                                        <p className="text-xs sm:text-sm text-red-600">⚠️ {ratingError}</p>
                                    </div>
                                )}

                                {/* ✅ Action Buttons */}
                                <div className="flex gap-2 sm:gap-3">
                                    <button
                                        onClick={handleCancelUpdate}
                                        disabled={isSubmittingRating}
                                        className="flex-1 px-4 sm:px-6 py-2.5 sm:py-3 rounded-xl border-2 border-gray-300 text-gray-600 font-semibold hover:bg-gray-100 hover:border-gray-400 transition duration-200 dark:border-navy-600 dark:text-gray-400 dark:hover:bg-navy-700 text-sm sm:text-base"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleSubmitRating}
                                        disabled={tempRating === 0 || isSubmittingRating}
                                        className={`flex-1 px-4 sm:px-6 py-2.5 sm:py-3 rounded-xl font-semibold transition duration-200 shadow-md text-sm sm:text-base flex items-center justify-center gap-2
                                            ${tempRating > 0 && !isSubmittingRating
                                            ? 'bg-[#004c86] text-white hover:bg-blue-800 cursor-pointer'
                                            : 'bg-gray-200 text-gray-400 cursor-not-allowed dark:bg-navy-700 dark:text-gray-500'
                                        }`}
                                    >
                                        {isSubmittingRating ? (
                                            <>
                                                <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
                                                </svg>
                                                Updating...
                                            </>
                                        ) : (
                                            'Update Rating'
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* ✅ Success Message */}
                    {ratingSuccess && (
                        <div className="px-4 sm:px-8 py-3 sm:py-4 bg-green-50 dark:bg-green-900/10">
                            <div className="flex items-center gap-2 sm:gap-3 max-w-md mx-auto">
                                <span className="text-xl sm:text-2xl flex-shrink-0">🎉</span>
                                <p className="text-xs sm:text-sm font-medium text-green-700 dark:text-green-400">
                                    Your rating has been submitted successfully!
                                </p>
                            </div>
                        </div>
                    )}
                </div>

                {/* ✅ Tabs Navigation */}
                <div className="flex border-b border-gray-200 dark:border-navy-700">
                    <button
                        onClick={() => setActiveTab('ingredients')}
                        className={`flex-1 px-3 sm:px-6 py-3 sm:py-4 text-sm sm:text-lg font-semibold transition duration-200 ${
                            activeTab === 'ingredients'
                                ? 'text-[#004c86] border-b-4 border-[#004c86] bg-blue-50 dark:text-white dark:border-[#004c86] dark:bg-navy-900'
                                : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-navy-900'
                        }`}
                    >
                        📝 <span className="hidden sm:inline">Ingredients</span>
                        <span className="inline sm:hidden">Ingredients</span>
                    </button>
                    <button
                        onClick={() => setActiveTab('steps')}
                        className={`flex-1 px-3 sm:px-6 py-3 sm:py-4 text-sm sm:text-lg font-semibold transition duration-200 ${
                            activeTab === 'steps'
                                ? 'text-[#004c86] border-b-4 border-[#004c86] bg-blue-50 dark:text-white dark:border-[#004c86] dark:bg-navy-900'
                                : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-navy-900'
                        }`}
                    >
                        👨‍🍳 <span className="hidden sm:inline">Instructions</span>
                        <span className="inline sm:hidden">Instructions</span>
                    </button>
                </div>

                {/* ✅ Tab Content */}
                <div className="p-4 sm:p-6 md:p-8">

                    {/* Ingredients Tab */}
                    {activeTab === 'ingredients' && (
                        <div className="animate-fadeIn">
                            <h2 className="text-xl sm:text-2xl font-bold text-navy-700 dark:text-white mb-4 sm:mb-6">
                                What You'll Need
                            </h2>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                                {recipe.ingredients && recipe.ingredients.length > 0 ? (
                                    recipe.ingredients.map((ingredient, index) => (
                                        <div
                                            key={index}
                                            className="flex items-start gap-3 p-3 sm:p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition duration-200 dark:bg-navy-900 dark:hover:bg-navy-700"
                                        >
                                            <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 bg-[#004c86] text-white rounded-full flex items-center justify-center text-xs sm:text-sm font-bold mt-0.5">
                                                {ingredient.displayOrder}
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <p className="text-sm sm:text-base text-gray-800 dark:text-gray-200">
                                                    {typeof ingredient === 'string' ? ingredient : (
                                                        <>
                                                            <span className="font-semibold">
                                                                {ingredient.quantity} {ingredient.unit}
                                                            </span>{' '}
                                                            {ingredient.ingredientName}
                                                            {ingredient.note && (
                                                                <span className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
                                                                    {' '}({ingredient.note})
                                                                </span>
                                                            )}
                                                        </>
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p className="col-span-2 text-gray-500 dark:text-gray-400 text-center py-8">
                                        No ingredients listed
                                    </p>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Steps Tab */}
                    {activeTab === 'steps' && (
                        <div className="animate-fadeIn">
                            {recipe.chefTip && (
                                <div className="mt-2 mb-3 p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded dark:bg-yellow-900/20 dark:border-yellow-500">
                                    <p className="text-xs sm:text-sm text-yellow-800 dark:text-yellow-300">
                                        💡 <span className="font-semibold">Tip:</span> {recipe.chefTip}
                                    </p>
                                </div>
                            )}
                            <h2 className="text-xl sm:text-2xl font-bold text-navy-700 dark:text-white mb-4 sm:mb-6">
                                Step-by-Step Instructions
                            </h2>
                            <div className="space-y-4 sm:space-y-6">
                                {recipe.steps && recipe.steps.length > 0 ? (
                                    recipe.steps.map((step, index) => (
                                        <div
                                            key={index}
                                            className="flex gap-3 sm:gap-4 p-4 sm:p-6 bg-gray-50 rounded-xl hover:shadow-md transition duration-200 dark:bg-navy-900"
                                        >
                                            <div className="flex-shrink-0">
                                                <div className="w-9 h-9 sm:w-12 sm:h-12 bg-[#004c86] text-white rounded-full flex items-center justify-center text-base sm:text-xl font-bold shadow-lg dark:bg-navy-600">
                                                    {step.stepNumber || index + 1}
                                                </div>
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                {step.title && (
                                                    <h3 className="text-base sm:text-lg font-bold text-navy-700 dark:text-white mb-1 sm:mb-2">
                                                        {step.title}
                                                    </h3>
                                                )}
                                                <p className="text-sm sm:text-base leading-relaxed text-gray-800 dark:text-gray-200">
                                                    {typeof step === 'string' ? step : step.instruction}
                                                </p>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p className="text-gray-500 dark:text-gray-400 text-center py-8">
                                        No instructions available
                                    </p>
                                )}
                            </div>
                        </div>
                    )}
                </div>

                {/* ✅ Chef's Notes */}
                {recipe.notes && (
                    <div className="p-4 sm:p-6 md:p-8 bg-blue-50 border-t border-blue-100 dark:bg-navy-900 dark:border-navy-700">
                        <h3 className="text-lg sm:text-xl font-bold text-navy-700 dark:text-white mb-2 sm:mb-3">
                            📌 Chef's Notes
                        </h3>
                        <p className="text-sm sm:text-base text-gray-700 dark:text-gray-300 leading-relaxed">
                            {recipe.notes}
                        </p>
                    </div>
                )}

            </div>
        </div>
    );
};

export default RecipeDetail;